import React, { useState, useEffect,useRef } from 'react';
import '../Filter/Filter.css';
import '../../common/CommonText.css';

const GroupBy = ({ options, selectedOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Ensure first option is selected by default if nothing is passed
  useEffect(() => {
    if (!selectedOption && options.length > 0) {
      onSelect(options[0]);
    }
  }, [options, selectedOption, onSelect]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="filter-container">
      <div className="filter-text-container">
        <label className="common-text fts-15 ftw-4 dk-gray">Group By</label>
      </div>

      <div className="custom-dropdown" ref={dropdownRef} onClick={() => setIsOpen(!isOpen)}>
        <div className="selected-option fts-13 lt-gray">
          {selectedOption || options[0]}
          <span className={`filter-dropdown-icon fts-12 ${isOpen ? 'open' : ''}`}>▼</span>
        </div>
        {isOpen && (
          <ul className="options-list">
            {options.map((option, index) => (
              <li
                key={index}
                className={`option-item dk-gray fts-13 ${selectedOption === option ? 'selected' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOptionClick(option);
                }}
              >
                <span className="check-icon fts-13">
                  {selectedOption === option ? '✔' : ''}
                </span>
                {option}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default GroupBy;
